//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Box from "./Box";
import ProductDetails from "./ProductDetails";
import SaveDrawer from "./SaveDrawer";
import SizingHelp from "./SizingHelp";
import Shipping from "./Shipping";
import MileElements from "./MileElements";
import mpi from "../../../plugins/merge";
import Embossing from "./Embossing";
import Bails from "./Bails";
import ProductMedia from "@/components/shop/conf/ProductMedia.vue";
import ProductStones from "@/components/shop/conf/ProductStones.vue";
import UiBreadcrumbs from "@/components/Ui/UiBreadcrumbs.vue";
import GeneralConfiguratorControls from "@/components/shop/conf/GeneralConfiguratorControls";

export default {
  name: 'Main',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    changingProduct: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Bails,
    Embossing,
    Shipping,
    ProductDetails,
    Box,
    SaveDrawer,
    MileElements,
    SizingHelp,
    ProductMedia,
    UiBreadcrumbs,
    ProductStones,
    GeneralConfiguratorControls,
  },
  data() {
    // RD - round
    // OV - Oval
    // EM - emerald
    // PC - princess
    //
    // DMND - diamond
    // RUBY - ruby
    // SPHR - sapphire
    // EMRD - green emerald
    // BD - black diamond
    // MOS - African Moonstone
    // ONX - Onyx
    // AQU - Aquamarine
    // HOP - Ethiopian Opal
    return {
      fonts: ['Times New Roman', 'Helvetica', 'Snell'],
      loading: true,
      url: `${process.env.IMAGE_URL}/${this.info.vendor_model}/`,
      drawer: false,
      drawerType: 'productDetails',
      loaded: false,
      stoneIndex: 0,
      vm: '',
      stage: 'configuration-edit',
      views: this.info.request_config.length ? this.sortImages(this.info.request_config[0].images) : this.sortImages(this.info.default_config.images),
      typeMaterial: this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().metalType).map(item => {
        return {...item, title: item.name}
      }),
      symbols: this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().symbols).map(item => {
        return {...item, title: item.name}
      }),
      stoneTypes: [this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneType || item.attribute_group === this.constAttributeGroups().beadType || item.attribute_group === this.constAttributeGroups().groupCabochon).map(item => {
        return {...item, title: item.name}
      }), this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneType2).map(item => {
        return {...item, title: item.name}
      })],
      stoneShapes: [this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut || item.attribute_group === this.constAttributeGroups().symbols).map(item => {
        return {...item, title: item.name}
      }), this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut2).map(item => {
        return {...item, title: item.name}
      })],
      sizes: this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      }),
      inlayList: this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().inlay).map(item => {
        return {...item, title: item.name}
      }),
      boxColor: this.info.package && this.info.package.types ? this.info.package.types : [],
      mt: '',
      s: '',
      ss: '',
      st: '',
      image: null,
      giftCardAmountList: [
        100,
        250,
        500,
        750,
        1000,
        2000
      ],
      giftCardData: {
        giftcard_amount: null,
        giftcard_from: '',
        giftcard_to: '',
        giftcard_note: '',
        giftcard_email: '',
        showRecipient: this.info?.theme.id === this.$productServiceData.productThemesList.giftCardDigital,
        resetForm: false
      },
      addToBagLoading: false,
      pendants: [],
    }
  },
  provide() {
    return {
      giftCardAmountList: this.giftCardAmountList,
      giftCardData: this.giftCardData,
    };
  },
  methods: {
    setPendants() {
      const result = [];
      const urlProductsIdList = this.$route.query.configId.split(',').filter((item, i) => i);
      if (urlProductsIdList.length) {
        urlProductsIdList.forEach((item, index) => {
          if (item && this.productInfo(item)) {
            const product = JSON.parse(JSON.stringify(this.productInfo(item)));
            product.urlIndex = index;
            result.push(product);
          }
        })
      }
      this.pendants = result;
    },
    productInfo(item) {
      let productUrlConfigIdPart = item.split('|')[0];
      return this.info.request_config.find(i => i.configuration_id.includes(productUrlConfigIdPart));
    },
    imagesLoaded() {
      this.loading = false;
    },
    isLoading(e) {
      this.loading = e
    },
    sizeChanged(size) {
      this.s = size
    },
    changeImage(image) {
      this.image = image
    },
    removeDuplicates(arr) {

      const result = [];
      const duplicatesIndices = [];

      arr.forEach((current, index) => {

        if (duplicatesIndices.includes(index)) return;

        result.push(current);

        for (let comparisonIndex = index + 1; comparisonIndex < arr.length; comparisonIndex++) {

          const comparison = arr[comparisonIndex];
          const currentKeys = Object.keys(current);
          const comparisonKeys = Object.keys(comparison);

          if (currentKeys.length !== comparisonKeys.length) continue;

          const currentKeysString = currentKeys.sort().join("").toLowerCase();
          const comparisonKeysString = comparisonKeys.sort().join("").toLowerCase();
          if (currentKeysString !== comparisonKeysString) continue;

          let valuesEqual = true;
          for (let i = 0; i < currentKeys.length; i++) {
            const key = currentKeys[i];
            if (current[key] !== comparison[key]) {
              valuesEqual = false;
              break;
            }
          }
          if (valuesEqual) duplicatesIndices.push(comparisonIndex);

        }
      });
      return result;
    },
    async uploadEngravingFile() {
      const data = new FormData();
      data.append('file', this.info.engraving_handwriting_file);

      try {
        const res = await this.$axios.post(`/products/engraving/upload`, data);
        return res.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async addToBag() {
      mpi.init();
      let image;
      if(document.querySelector('#product-container')) {
        image = await mpi.getMergedImage('#product-container', true);
      }
      if (document.querySelector('#box-photo')) {
        this.image = await mpi.getMergedImage('#box-photo', true);
      }

      this.loading = true;
      this.addToBagLoading = true;

      function DataURIToBlob(dataURI) {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
          ia[i] = byteString.charCodeAt(i)

        return new Blob([ia], {type: mimeString})
      }

      const options = {
        embossing_label: this.$route.query.embossing || '',
        embossing_font: this.$route.query.embossing && this.info.theme.id === this.constProductThemes().ringBrand ? 'Pragmatica Bold' : '',
        engraving_label: this.$route.query.e1 || '',
        engraving_font: this.$route.query.f1 ? this.fonts[Number(this.$route.query.f1)] : '',
        package_type: this.$route.query.bc ? this.info.package.types.find(item => item.name === this.$route.query.bc).id : null,
        package_label: this.$route.query.bt || ''
      }

      if (this.info.package && this.info.package.id) {
        options.package_id = this.info.package.id;
      }

      if (!this.isGiftCard) {
        options.package_wrap_id = this.$store.getters.isHolidayWrap ? 1 : null;
      }

      if (this.info.engraving_handwriting_file) {
        const file = await this.uploadEngravingFile();
        options.engraving_upload = JSON.stringify(file);
      }

      if(this.isGiftCard) {
        options.giftcard_amount = this.giftCardData.giftcard_amount;
        options.giftcard_from = this.giftCardData.giftcard_from;
        options.giftcard_to = this.giftCardData.giftcard_to;
        options.giftcard_note = this.giftCardData.giftcard_note;
        options.giftcard_email = this.giftCardData.giftcard_email || null;
      }

      if (this.info.dividable_pair) {
        options.is_pair = this.info.request_config?.length === 2 ? 1 : 0;
      }

      if (this.info.has_orientation && (this.$route.query.orientation === 'left' || this.$route.query.orientation === 'right')) {
        options.orientation = this.$route.query.orientation;
      }

      let formData = new FormData();
      if (this.image) {
        const package_image = DataURIToBlob(this.image)
        formData.append('package_image', package_image);
      }
      if(image) {
        const file = DataURIToBlob(image);
        formData.append('image', file);
      }
      formData.append('cart_unique_id', this.cartId);
      formData.append('sku', this.$route.query.configId);
      formData.append('quantity', '1');
      //formData.append('options', JSON.stringify(options));
      for (let key in options) {
        formData.append(`options[${key}]`, options[key]);
      }
      const urlProducts = this.$route.query.configId.split(',');
      urlProducts.forEach((item, index) => {
        if (item && index && this.$route.query[`e${index}_sub`]) {
          formData.append(`options[subitems][${index}][engraving_font]`, this.fonts[Number(this.$route.query[`f${index}_sub`])]);
          formData.append(`options[subitems][${index}][engraving_label]`, this.$route.query[`e${index}_sub`]);
        }
      });
      /*const params = {
        cart_unique_id: this.cartId,
        sku: this.$route.query.configId,
        quantity: 1,
        options: {
          engraving_label: this.$route.query.e1 || '',
          package_id: this.info.package.id,
          package_type: this.$route.query.bc ? this.info.package.types.find(item => item.name === this.$route.query.bc).id : null,
          package_label: this.$route.query.bt || ''
        }
      }*/
      this.$axios.post('/carts/items', formData)
        .then(res => {
          const data = res.data.data;
          data.cart?.items?.forEach(item => {
            if (item.options.engraving_upload) {
              item.options.engraving_upload = JSON.parse(item.options.engraving_upload);
            }
          });

          this.info.engraving_handwriting_file = null;
          this.resetGiftCardData();
          this.$store.commit('setLocalVar', {var: 'cart_unique_id', val: data.cart.unique_id});
          this.$store.commit('setStoreVar', {var: 'cart', val: data.cart.items});
          this.$store.commit('setStoreVar', {var: 'cartInfo', val: data.cart});
          document.querySelector('#cart-modal').classList.add('open-cart');
          setTimeout(() => {
            this.$store.commit('setStoreVar', {var: 'cartModal', val: true})
          }, 500)
        })
        .catch(err => {
          console.log(err);
          const giftCardForm = this.isGiftCard ? this.$refs?.configurator?.$refs?.giftCardControls?.$refs?.giftCardForm?.$refs?.form : null;
          if(giftCardForm) {
            this.setServerErrors(err, giftCardForm);
          }
        })
        .then(() => {
          this.loading = false;
          this.addToBagLoading = false;
        })
    },
    setServerErrors(err, formRef) {
      if(!formRef || !err.response.data?.errors?.length) {
        return;
      }
      const errors = {};
      err.response.data.errors.forEach(item => {
        if (item.code === 400) {
          errors[item.property] = [item.message];
        }
      })
      formRef.setErrors(errors);
    },
    resetGiftCardData() {
      this.giftCardData.giftcard_amount = null;
      this.giftCardData.giftcard_from = '';
      this.giftCardData.giftcard_to = '';
      this.giftCardData.giftcard_note = '';
      this.giftCardData.giftcard_email = '';
      this.giftCardData.showRecipient = this.info?.theme.id === this.$productServiceData.productThemesList.giftCardDigital;
      this.giftCardData.resetForm = true;
    },
    sortImages(images) {
      const sorted = Object.keys(images).sort().reduce(
        (obj, key) => {
          obj[key] = images[key];
          return obj;
        },
        {}
      );
      const arr = [];
      for (const i in sorted) {
        arr.push(sorted[i])
      }
      return arr
    },
    openDrawer({type}) {
      this.drawer = true
      this.drawerType = type
    },
    checkLoadedImages(item) {
      const promises = []

      function addImageProcess(img) {
        return new Promise((resolve, reject) => {
          img.onload = () => resolve(img)
          img.onerror = reject
        })
      }

      let images = document.querySelectorAll(`${item}`);
      if (images.length) {
        for (let img in images) {
          if (Object.prototype.hasOwnProperty.call(images, img)) {
            promises.push(addImageProcess(images[img]))
          }
        }
      }
      return Promise.all(promises)
    },
    changeStageFunc(e) {
      this.stage = e;
    },
    editStone(e) {
      this.stoneIndex = e;
    },
    closeDialog() {
      this.stage = 'configurator'
    },
    backStage() {
      this.stage = this.info.theme.id === this.constProductThemes().package ? 'configurator' : 'configuration-edit'
    },
    sendKlaviyoViewedProduct() {
      const _learnq = window._learnq || [];
      const price = this.total ? Number(this.total.replaceAll(',', '')).toFixed(2) : '0.00';
      const product = {
        "ProductName": this.info.name,
        "ProductID": this.info.id,
        "SKU": this.$route.query.configId,
        "Categories": [this.info.category_code],
        // "ImageURL": "http://www.example.com/path/to/product/image.png",
        "URL": window.location.href,
        "Price": price,
        // "CompareAtPrice": 14.99
      };
      _learnq.push(["track", "Viewed Product", product]);
    },
    setBoxText() {
      const canvas = document.querySelectorAll(".canvasBox");
      if (canvas) {
        canvas.forEach(item => {
          let ctx = item.getContext("2d");
          ctx.clearRect(0, 0, item.width, item.height);
          ctx.font = `700 ${this.stage !== 'configurator' ? 20 : 20}px Helvetica`;
          ctx.fillStyle = "#907e48";
          ctx.textAlign = "center";
          ctx.fillText(this.$route.query.bt ? this.$route.query.bt.toUpperCase() : '',
            item.width / 2 - 42,
            item.height / 2 + 210);
        })
      }
    },
    updateCanvas() {
      this.setBoxText();
      setTimeout(() => {
        this.setBoxText();
      }, 500)
      const drawTextAlongArc = (context, str, centerX, centerY, radius, angle, start, invert, fs, direction) => {
        if (!str) return
        if (str.length % 2 === 0) {
          str = str + " ";
        }
        let len = str.length, s;
        context.font = `${fs ? fs : '20'}px ${this.fonts[this.engraving.f]}`;
        context.textAlign = 'center';
        context.fillStyle = "#5b5a58";
        context.save();

        if (direction === 'horizontal') {
          context.fillText(this.engraving.e, centerX, centerY);
          return;
        }

        context.translate(centerX, centerY);
        context.rotate(-1 * start);
        context.rotate((invert ? 1 : -1) * (angle * len) / 2);
        for (let n = 0; n < len; n++) {
          context.rotate((invert ? -1 : 1) * angle);
          context.save();
          context.translate(0, (invert ? 1 : -1) * radius);
          s = str[n];
          context.fillText(s, 0, 0);
          context.restore();
        }
        context.restore();
      }
      const el = this.$el

      if (this.info.engraving_configs && this.info.engraving_configs.length) {
        this.info.engraving_configs.forEach((elm, i) => {
          const sel = `#canvasText${i}`;
          let e = this.$el.querySelectorAll(sel)
          e.forEach((canvas) => {
            let context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            let centerX = (canvas.width / 2) + elm.x,
              centerY = (canvas.height) + elm.y + (this.stage === 'configurator' ? +elm.configuratorY : 0),
              angle = elm.angle,
              radius = elm.radius,
              start = elm.start
            drawTextAlongArc(context, this.engraving.e, centerX, centerY, radius, angle, start, elm.invert, elm.fs, elm.direction);
          })
        })
      }

      /*switch (this.$route.params.slug.toLowerCase()) {
        case 'uno':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 20,
              centerY0 = (canvas0.height) + 126 + (this.stage === 'configurator' ? -4 : 0),
              angle0 = 0.022,
              radius0 = 720,
              start0 = 0.08

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0);
          })


          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) + 0,
              centerY1 = (canvas1.height) + 229 + (this.stage === 'configurator' ? -5 : 0),
              angle1 = 0.018,
              radius1 = 800,
              start1 = 0.00

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1);
          })

          var items2 = el.querySelectorAll('#canvasText2')
          items2.forEach((canvas2) => {
            let context2 = canvas2.getContext('2d');
            context2.clearRect(0, 0, canvas2.width, canvas2.height);
            let centerX2 = (canvas2.width / 2) - 340,
              centerY2 = (canvas2.height) - 804 + (this.stage === 'configurator' ? -8 : 0),
              angle2 = 0.028,
              radius2 = 600,
              start2 = 0.71

            drawTextAlongArc(context2, this.engraving.e, centerX2, centerY2, radius2, angle2, start2, true);
          })

          break;

        case 'unoc':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 20,
              centerY0 = (canvas0.height) + 126 + (this.stage === 'configurator' ? -4 : 0),
              angle0 = 0.022,
              radius0 = 720,
              start0 = 0.08

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })


          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) + 0,
              centerY1 = (canvas1.height) + 229 + (this.stage === 'configurator' ? -5 : 0),
              angle1 = 0.018,
              radius1 = 800,
              start1 = 0.00

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, false);
          })

          var items2 = el.querySelectorAll('#canvasText2')
          items2.forEach((canvas2) => {
            let context2 = canvas2.getContext('2d');
            context2.clearRect(0, 0, canvas2.width, canvas2.height);
            let centerX2 = (canvas2.width / 2) - 340,
              centerY2 = 210 + (this.stage === 'configurator' ? -24 : -16),
              angle2 = 0.028,
              radius2 = 600,
              start2 = 0.71

            drawTextAlongArc(context2, this.engraving.e, centerX2, centerY2, radius2, angle2, start2, true);
          })

          break;

        case 'cbo':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            var centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) - 78 + (this.stage === 'configurator' ? -3 : 0),
              angle0 = 0.029,
              radius0 = 540,
              start0 = 0.0

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })

          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 300,
              centerY1 = 246 + (this.stage === 'configurator' ? -6 : 0),
              angle1 = 0.029,
              radius1 = 540,
              start1 = 0.76

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;

        case 'cor':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            var centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) + 226 + (this.stage === 'configurator' ? -6 : 0),
              angle0 = 0.020,
              radius0 = 800,
              start0 = 0.0

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })

          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 340,
              centerY1 = 184 + (this.stage === 'configurator' ? -4 : -0),
              angle1 = 0.028,
              radius1 = 600,
              start1 = 0.76

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;

        case 'stmt':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            var centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) - 64 + (this.stage === 'configurator' ? -6 : 0),
              angle0 = 0.029,
              radius0 = 540,
              start0 = 0.0

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })

          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 300,
              centerY1 = 230 + (this.stage === 'configurator' ? -6 : 0),
              angle1 = 0.029,
              radius1 = 540,
              start1 = 0.76

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;

        case 'cabbg':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) + 464 + (this.stage === 'configurator' ? -4 : 0),
              angle0 = 0.015,
              radius0 = 1060,
              start0 = 0.0

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })

          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 588 + (this.stage === 'configurator' ? 2 : 0),
              centerY1 = 50 + (this.stage === 'configurator' ? -10 : -0),
              angle1 = 0.018,
              radius1 = 900,
              start1 = 0.88 + (this.stage === 'configurator' ? -0.02 : -0)

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;

        case 'duobg':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) + 464 + (this.stage === 'configurator' ? -4 : 0),
              angle0 = 0.015,
              radius0 = 1060,
              start0 = 0.0

            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })

          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 588 + (this.stage === 'configurator' ? 2 : 0),
              centerY1 = 50 + (this.stage === 'configurator' ? -10 : -0),
              angle1 = 0.018,
              radius1 = 900,
              start1 = 0.88 + (this.stage === 'configurator' ? -0.02 : -0)

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;
          const duo = [
        {
          x: 0,
          y: -74,
          configuratorY: -3,
          angle: 0.029,
          radius: 540,
          start: 0.00,
          invert: false
        },
        {
          x: -340,
          y: -820,
          configuratorY: -4,
          angle: 0.028,
          radius: 600,
          start: 0.76,
          invert: true
        }
      ]

        case 'duo':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) - 74 + (this.stage === 'configurator' ? -3 : 0),
              angle0 = 0.029,
              radius0 = 540,
              start0 = 0.0
            drawTextAlongArc(context0, this.engraving.e, centerX0, centerY0, radius0, angle0, start0, false);
          })
          var items1 = el.querySelectorAll('#canvasText1')
          items1.forEach((canvas1) => {
            let context1 = canvas1.getContext('2d');
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            let centerX1 = (canvas1.width / 2) - 340,
              centerY1 = 180 + (this.stage === 'configurator' ? -4 : -0),
              angle1 = 0.028,
              radius1 = 600,
              start1 = 0.76

            drawTextAlongArc(context1, this.engraving.e, centerX1, centerY1, radius1, angle1, start1, true);
          })

          break;

        case 'mile':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            var centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) + 140 + (this.stage === 'configurator' ? 0 : 0),
              angle0 = 0.024,
              radius0 = 720,
              start0 = 0.0
            drawTextAlongArc(context0, this.sliderValue === 0 ? this.engraving.e : '', centerX0, centerY0, radius0, angle0, start0, false);
          })
          break

        case 'mlbg':
          var items0 = el.querySelectorAll('#canvasText0')
          items0.forEach((canvas0) => {
            let context0 = canvas0.getContext('2d');
            context0.clearRect(0, 0, canvas0.width, canvas0.height);
            let centerX0 = (canvas0.width / 2) + 0,
              centerY0 = (canvas0.height) + 466 + (this.stage === 'configurator' ? 2 : 0),
              angle0 = 0.015,
              radius0 = 1060,
              start0 = 0.0

            drawTextAlongArc(context0, this.sliderValue === 0 ? this.engraving.e : '', centerX0, centerY0, radius0, angle0, start0);
          })

          break
      }*/

      if (this.stage === 'engraving' && this.info.assets.engraving_image) {
        var items0 = el.querySelectorAll('#canvasTextE')
        items0.forEach((canvas0) => {
          let context0 = canvas0.getContext('2d');
          context0.clearRect(0, 0, canvas0.width, canvas0.height);
          var centerX0 = (canvas0.width / 2) + -1570,
            centerY0 = (canvas0.height) + 19450 + (this.stage === 'configurator' ? +1 : 0),
            angle0 = 0.001,
            radius0 = 20000,
            start0 = -0.095

          drawTextAlongArc(context0, this.sliderValue === 0 ? this.engraving.e : '', centerX0, centerY0, radius0, angle0, start0, false, 26);
        })
      }
    }
  },
  watch: {
    isMobile(val) {
      this.$nextTick(() => {
        this.updateCanvas();
      });
    },
    stage(val) {
      window.scroll(0, 0);
      this.$refs?.configuratorControlsColumn?.scroll(0, 0);
      this.$nextTick(() => {
        this.updateCanvas();
      })
    },
    info() {
      this.views = this.info.request_config.length ? this.sortImages(this.info.request_config[0].images) : this.sortImages(this.info.default_config.images)
      this.typeMaterial = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().metalType).map(item => {
        return {...item, title: item.name}
      });
      this.stoneTypes = [this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneType || item.attribute_group === this.constAttributeGroups().beadType || item.attribute_group === this.constAttributeGroups().groupCabochon).map(item => {
        return {...item, title: item.name}
      }), this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneType2).map(item => {
        return {...item, title: item.name}
      })],
        this.stoneShapes = [this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut || item.attribute_group === this.constAttributeGroups().symbols).map(item => {
          return {...item, title: item.name}
        }), this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().stoneCut2).map(item => {
          return {...item, title: item.name}
        })];
      this.sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      this.symbols = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().symbols).map(item => {
        return {...item, title: item.name}
      });
      this.inlayList = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().inlay).map(item => {
        return {...item, title: item.name}
      });
      if (!this.$route.query.bc && this.boxColor && this.boxColor.length && this.info.theme.id !== this.constProductThemes().package) {
        /*const query = {...this.$route.query, bc: this.boxColor[0].name};
        this.$router.replace({query});*/
      }
      this.setPendants();
    },
    dialog(val) {
      if (val) {
        document.documentElement.classList.add('overflow-hidden')
      } else {
        document.documentElement.classList.remove('overflow-hidden')
      }
    },
  },
  computed: {
    total() {
      let packageCost = this.$route.query.bc && this.info.package.types.some(item => item.name === this.$route.query.bc)
        ? this.info.package.types.find(item => item.name === this.$route.query.bc).cost : 0;
      let engraving = this.$route.query.e1 ? this.$route.query.e1.length * this.info.engraving_cost : 0;
      let embossing = this.$route.query.embossing ? this.$route.query.embossing.length * this.info.embossing_cost : 0;
      /*const temp = this.info.request_config ?
        Number(this.info.request_config.map(item => item.cost).reduce((prev, next) => Number(prev) + Number(next))) + engraving + embossing :
        Number(this.info.default_config.map(item => item.cost).reduce((prev, next) => Number(prev) + Number(next))) + engraving + embossing*/
      const res = (this.info.cost + (embossing ? Number(embossing) : 0) + (engraving ? Number(engraving) : 0) + (packageCost ? Number(packageCost) : 0)).globalRoundTo(5)

      return res && res !== 'NaN' ? this.numberWithCommas(res) : '0'
    },
    totalWithSale() {
      let packageCost = this.$route.query.bc && this.info.package.types.some(item => item.name === this.$route.query.bc)
        ? this.info.package.types.find(item => item.name === this.$route.query.bc).cost : 0;
      let engraving = this.$route.query.e1 ? this.$route.query.e1.length * this.info.engraving_cost : 0;
      let embossing = this.$route.query.embossing ? this.$route.query.embossing.length * this.info.embossing_cost : 0;
      /*const temp = this.info.request_config ?
        Number(this.info.request_config.map(item => item.cost).reduce((prev, next) => Number(prev) + Number(next))) + engraving + embossing :
        Number(this.info.default_config.map(item => item.cost).reduce((prev, next) => Number(prev) + Number(next))) + engraving + embossing*/
      const res = (this.info.cost_with_sale + (embossing ? Number(embossing) : 0) + (engraving ? Number(engraving) : 0) + (packageCost ? Number(packageCost) : 0))
      return res && res !== 'NaN' ? this.numberWithCommas(this.roundedToUp(res), false) : '0'
    },
    hasValentinesDaySale() {
      return this.info.sale && this.info.sale.code === 'VDAY'
    },
    totalMain() {
      return this.hasValentinesDaySale ? this.totalWithSale : this.total
    },
    productTypeLabel() {
      return this.info.category_code && this.info.category_code !== 'packaging' ? this.info.category_code.substring(0, this.info.category_code.length - 1) : this.info.category_code === 'packaging' ? 'packaging' : 'product';
    },
    engraving() {
      return {
        e: this.$route.query.e1,
        f: Number(this.$route.query.f1),
      }
    },
    embossing() {
      return this.$route.query.embossing
    },
    cartId() {
      return this.$store.getters.getCartId
    },
    selected() {
      let arr = this.$route.query.configId ? this.$route.query.configId.split(',')[0].split('-') : [];

      const stones = [];
      let index = this.sizes.length ? 2 : 1;
      arr.forEach((item, i) => {
        if (i && i < (arr.length - index)) {
          const a = {};
          if (this.stoneShapes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1]
            && this.stoneShapes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1].some(item => item.value === arr[i].substr(0, 2))) {
            a.ss = this.stoneShapes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1].find(item => item.value === arr[i].substr(0, 2))
          } else if (this.symbols && this.symbols.some(item => item.value === arr[i])) {
            a.ss = this.symbols.find(item => item.value === arr[i])
          }
          if (this.stoneTypes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1]
            && this.stoneTypes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1].some(item => item.value === arr[i].substr(2))) {
            a.st = this.stoneTypes[(this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone) ? 0 : i - 1].find(item => item.value === arr[i].substr(2))
          } else if (this.symbols && this.symbols.some(item => item.value === arr[i])) {
            a.st = this.symbols.find(item => item.value === arr[i])
          } else if (this.onlyStoneTypeThemesGroup &&
            this.stoneTypes[0].some(item => item.value === arr[i])) {
            a.st = this.stoneTypes[0].find(item => item.value === arr[i])
          }
          // TODO Even an empty object must be added to the array, otherwise the logic of milestone products will break
          stones.push(a);
        }
      })
      // console.log('stones', stones);
      return {
        stones,
        m: this.typeMaterial.some(item => item.value === arr[arr.length - index]) ?
          this.typeMaterial.find(item => item.value === arr[arr.length - index]).value :
          '',
        inlay: this.inlayList?.length ? this.inlayList.find(item => item.value === arr[2]) : ''
      }
    },
    dialog: {
      get() {
        return this.stage !== 'configurator'
      },
      set(val) {

      }
    },
    dialogHeaderTitle() {
      // console.log('this.stage', this.stage);
      switch (this.stage) {
        case 'configuration-edit': {
          return {
            title: this.info.name,
            hasBack: false
          }
        }
        case 'edit-stone': {
          return {
            title: this.$t('stones'),
            hasBack: true
          }
        }
        case 'MileElements': {
          return {
            title: this.$t('milestoneElements'),
            hasBack: true
          }
        }
        case 'Pendants': {
          return {
            title: this.$t('pendants'),
            hasBack: true
          }
        }
        case 'box': {
          return {
            title: this.info.theme.id === this.constProductThemes().package ? this.info.name : this.info.package.name,
            hasBack: true
          }
        }
        case 'engraving': {
          return {
            title: this.$t('engravings'),
            hasBack: true
          }
        }
        default: {
          return {
            title: this.info.name,
            hasBack: false
          }
        }
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.width <= 920
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    showEngravingPlaceholder() {
      return !!this.info.engraving_handwriting_file || this.info.engraving_configs[0]?.engraving_images &&
        !this.$route.query.e1 && !this.$route.query.e1?.length && this.info.vendor_model.toLowerCase() === 'sonlsgchn';
    },
    isGiftCard() {
      return this.info?.theme?.id === this.$productServiceData.productThemesList.giftCardDigital || this.info?.theme?.id === this.$productServiceData.productThemesList.giftCardPhysical;
    },
    onlyStoneTypeThemesGroup() {
      return this.info.theme.id === this.constProductThemes().beadNecklace ||
        this.info.theme.id === this.constProductThemes().beadBracelet ||
        this.info.theme.id === this.constProductThemes().earringStoneMetal ||
        this.info.theme.id === this.constProductThemes().ringStoneMetalSize ||
        this.info.theme.id === this.constProductThemes().pendantStoneMetal ||
        this.info.theme.id === this.constProductThemes().pendantStoneMetalChained ||
        this.info.theme.id === this.constProductThemes().cabochon ||
        this.info.theme.id === this.constProductThemes().cabochonNecklace ||
        this.info.theme.id === this.constProductThemes().stoneNecklace;
    },
    breadcrumbs() {
      return [
        {
          text: 'Shop',
          href: '/catalog',
          disabled: false
        },
        {
          text: this.info.name,
          action: () => {
            this.changeStageFunc('configuration-edit');
          },
        },
      ]
    },
  },
  created() {
    this.setPendants();
  },
  beforeMount() {
    this.$on('imagesLoaded', this.imagesLoaded);
    this.$root.$on('loading', this.isLoading);
    this.$on('addToBag', this.addToBag);
    this.$on('changeImage', this.changeImage);
    this.$on('sizeChanged', this.sizeChanged);
    if (!this.isGiftCard && this.$route.query.configId) {
      let query = {...this.$route.query, configId: this.$route.query.configId};
      if (this.info.request_config.length &&
        this.info.connected_count &&
        this.$route.query.configId.split(',').length === 1) {
        let c = this.$route.query.configId;
        for (let a = 1; a <= this.info.connected_count; a++) {
          c = c + ',';
        }
        if (this.$route.query.configId !== c) {
          query.configId = c;
        }
      }
      const availableBoxes = this.boxColor.filter(item => !item.out_of_stock);
      if ((!this.$route.query.bc && availableBoxes.length && this.info.theme.id !== this.constProductThemes().package) ||
        (availableBoxes.length && !availableBoxes.some(item => item.name === query.bc))
      ) {
        query.bc = availableBoxes[0].name;
      }
      if (query.bc || query.configId !== this.$route.query.configId) {
        if (query.bc && !availableBoxes.length) {
          delete query.bc;
        }
        this.$router.replace({query}).catch(err => {});
      }
    }
    setTimeout(() => {
      if (this.info.theme.id !== this.constProductThemes().oneConfigProduct && !this.isGiftCard && this.$route.query.configId) {
        this.vm = this.$route.query.configId;
        let index = this.sizes.length ? 2 : 1;
        this.mt = this.vm.split(',')[0].split('-')[this.vm.split(',')[0].split('-').length - index];
        this.s = this.vm.split(',')[0].split('-')[this.vm.split(',')[0].split('-').length - 1];
        this.ss = this.vm.split(',')[0].split('-')[1].substr(0, 2);
        this.st = this.vm.split(',')[0].split('-')[1].substr(2);
      }
    })

    this.$on('changeMetal', (event) => {
      this.mt = event
    })

    this.$on('changeStage', (event) => {
      this.changeStageFunc(event)
    })

    this.$on('editStone', (event) => {
      this.editStone(event)
    })

    this.$on('openDrawer', (type) => {
      this.openDrawer(type)
    })
  },
  mounted() {
    this.updateCanvas();
    setTimeout(() => {
      this.updateCanvas();
    }, 500);
    if(this.userInfo?.email) {
      setTimeout(() => {
        this.sendKlaviyoViewedProduct();
      }, this.$store.getters.getAnalyticsMarketingLoadTimeout + 500);
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove('overflow-hidden')
  }
}
